import { set } from 'lodash';
import { useSelector } from 'react-redux';
import { detailedCostingFieldpath } from '../../../ProductCosting/fieldPath';
import { roundingOff } from '../../../../../Components/helper';

export default function useDetailedCostingHooks(productInfoObj) {
  const { setProductCostingState, productCostingstate } = productInfoObj;
  const {
    ProductCostingData: { productLengths },
  } = useSelector((reduxState) => reduxState);
  const { isBreakdown } = productCostingstate;

  const calculateDetailCosting = async (state) => {
    const manipulatedData = [];
    // loop 1st bom list array
    const copyState = state;
    if (Array.isArray(copyState?.detailedCosting?.bomTypeArr) && copyState?.detailedCosting?.bomTypeArr.length > 0) {
      for (const data of copyState.detailedCosting.bomTypeArr) {
        const detailedCostingInfo = [];
        let overAllSumOfTotalPrice = '0';
        let overAllSumOfQuantityPerSizCol = '0';
        let overAllSumPricePerUnit = '0';
        const totColourways = [];

        // loop 1st detailed costing info array
        if (Array.isArray(data.detailedCostingInfo) && data.detailedCostingInfo.length > 0) {
          for (const element of data.detailedCostingInfo) {
            // loop 1st expand data info array
            let sumOfTotalPrice = '0';
            let sumOfQuantityPerSizCol = '0';
            let sumPricePerUnit = '0';
            const totLength = [];
            const totSize = [];
            totColourways.push(element?.colourway?.name);
            if (Array.isArray(element.expandData) && element.expandData.length > 0) {
              if (isBreakdown) {
                element.expandData.forEach((expLoop) => {
                  if (productLengths && productLengths.length > 0) {
                    totLength.push(expLoop?.length?.name);
                  }
                  totSize.push(expLoop?.size);
                });
              }
              for (const [i, expandData] of element.expandData.entries()) {
                const { quantityPerSizCol } = expandData;
                const totalPrice = roundingOff(expandData.pricePerUnit * quantityPerSizCol, 4);
                const { pricePerUnit } = expandData;
                expandData.totalPrice = totalPrice;
                if (!isBreakdown) {
                  if (!expandData.isExcluded) {
                    sumOfTotalPrice = +sumOfTotalPrice + +totalPrice;
                    sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
                    sumPricePerUnit = +sumPricePerUnit + +pricePerUnit;
                  }
                  if (productLengths && productLengths.length > 0) {
                    totLength.push(expandData?.length?.name);
                  }
                  totSize.push(expandData?.size);
                } else if (isBreakdown && i === 0) {
                  if (!expandData.isExcluded) {
                    sumOfTotalPrice = +sumOfTotalPrice + +totalPrice;
                    sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
                    sumPricePerUnit = +sumPricePerUnit + +pricePerUnit;
                  }
                }
              }
            }
            overAllSumOfTotalPrice = +overAllSumOfTotalPrice + +sumOfTotalPrice;
            overAllSumOfQuantityPerSizCol = +overAllSumOfQuantityPerSizCol + +sumOfQuantityPerSizCol;
            overAllSumPricePerUnit = +overAllSumPricePerUnit + +sumPricePerUnit;

            element.sumOfQuantityPerSizCol = sumOfQuantityPerSizCol;
            element.sumTotalPrice = sumOfTotalPrice;
            element.sumOfPricePerUnit = sumPricePerUnit;
            // exapnd data to show comma separted data
            element.totLength = [...new Set(totLength)];
            element.totSize = [...new Set(totSize)];
            element.totColourways = [...new Set(totColourways)];
            // to sghow overall one bom data coloure,size,length
            data.totLength = [...new Set(totLength)];
            data.totSize = [...new Set(totSize)];
            data.totColourways = [...new Set(totColourways)];
            element.sizeRange = totSize
              .filter((item, index) => totSize.indexOf(item) === index)
              .map((vl) => {
                return { name: vl, label: vl };
              });
            element.lengthRange = totLength
              .filter((item, index) => totLength.indexOf(item) === index)
              .map((vl) => {
                return { name: vl, label: vl };
              });
            detailedCostingInfo.push(element);
          }
        }
        data.overAllSumOfQuantityPerSizCol = overAllSumOfQuantityPerSizCol;
        data.overAllSumOfTotalPrice = overAllSumOfTotalPrice;
        data.overAllSumPricePerUnit = overAllSumPricePerUnit;
        data.detailedCostingInfo = detailedCostingInfo;
        manipulatedData.push(data);
      }
    }
    set(copyState, detailedCostingFieldpath().DETAILED_COSTING_DATA, manipulatedData);
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
  };
  return { calculateDetailCosting };
}
